import { api_POST } from "../api/_axios.js";

const analiseboletim_api =
{
    analiseReincidencias: function(json_submit){
        const promise = new Promise((resolve, reject) => { 
            api_POST(`AnaliseBoletim/AnaliseReincidencias`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    post: function(json_submit){
        const promise = new Promise((resolve, reject) => { 
            api_POST(`AnaliseBoletim`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    postPedidoVistas: function(json_submit){
        const promise = new Promise((resolve, reject) => { 
            api_POST(`AnaliseBoletim/PostPedidoVistas`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    putPedidoVistas: function(json_submit){
        const promise = new Promise((resolve, reject) => { 
            api_POST(`AnaliseBoletim/PutPedidoVistas`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

}

export default analiseboletim_api
